export default __webpack_public_path__ + "static/volvo-f3139bc75a11c7ab0980e26e1d3a50ba.jpg";